import clsx from 'clsx';
import { RefObject } from 'react';
import s from './NavBar.module.scss';

export const getProfileNavbarClassName = (
  isMobileView?: boolean,
  isRenderedInModal?: boolean,
  showBack?: boolean,
  isMiniContactPanelVisible?: boolean,
): string => {
  const commonClass = s.navBar;

  const baseNavbarClass = isMobileView
    ? s.scrollingWrapper
    : isRenderedInModal
    ? s.navnoHeader
    : s.nav;

  const backClass =
    !isMobileView && !isRenderedInModal && showBack ? s.withBack : '';
  const miniContactPanelClass =
    isMobileView && isMiniContactPanelVisible ? s.withMiniContactPanel : '';

  return clsx(commonClass, baseNavbarClass, backClass, miniContactPanelClass);
};

export const getNavContentClass = (isMobileView?: boolean): string =>
  isMobileView ? s.navContentMobile : s.navContentDesktop;

export const updateWindowHistory = (section: string): void => {
  const { pathname, search } = window.location;
  const url = `${pathname}${search}#${section}`;
  window.history.replaceState(null, '', url);
};

export const focusNavigationElement = (
  navigationRefs: RefObject<Record<string, HTMLElement>>,
  section: string,
  preventScroll = true,
): void => {
  navigationRefs.current?.[section]?.focus({ preventScroll });
};

// for accessibility
export const getNavbarSectionByFocusTarget = (
  navigationRefs: React.RefObject<Record<string, HTMLElement>>,
  navbarSections: Array<{ section: string }>,
  target: Node | null,
): string | undefined => {
  if (!target || !navigationRefs.current) return undefined;
  const preferred = navbarSections.map((s) => s.section);
  return preferred.find((id) => navigationRefs.current?.[id]?.contains(target));
};
